import React from "react";
import { createRoot } from "react-dom/client";
import { config } from "react-spring";
// import markerSDK from "@marker.io/browser";
import { Router } from "react-router";
import "./utils/polyfills";
import history from "./utils/history";
import { Provider } from "react-redux";
import AppBoundary from "./AppBoundary";

import { store } from "./store";

import App from "./App";
import "./styles/fontLibrary";
import "./index.css";
import { setDispatch } from "./utils/errorHandling";
import { setMessageDispatch } from "./store/actions/message";
import { initSentry } from "./utils/sentry";
import { isLocalDevServer } from "./utils/env";

initSentry();

if (window.Cypress) {
  window.store = store;
  config.default = { duration: 0 };
}

setDispatch(store.dispatch);
setMessageDispatch(store.dispatch);

// Promises that need to be resolved before we render React.
const promises = [];

// IO2-1649 warning: why-did-you-render causes crashes in Vite.
if (process.env.NODE_ENV === "development" && process.env.REACT_APP_WDYR) {
  promises.push(
    new Promise(async (resolve) => {
      const whyDidYouRender = await import(
        "@welldone-software/why-did-you-render"
      );
      whyDidYouRender.default(React, {
        trackAllPureComponents: true,
        exclude: excludeForWhyDidYouRender,
      });
      resolve();
    })
  );
}

if (isLocalDevServer) {
  window.__debug = {
    getState: store.getState,
  };
}

Promise.all(promises).then(() =>
  createRoot(document.getElementById("root")).render(
    <Provider store={store}>
      <Router history={history}>
        <AppBoundary>
          <App />
        </AppBoundary>
      </Router>
    </Provider>
  )
);

const excludeForWhyDidYouRender = [
  /ResizeDetector/,
  /ChartFactory/,
  /ChildWrapper/,
  /AutoSizer/,
  /Table/,
  /Grid/,
  /ScrollBlock/,
  /AnimateInOut/,
  /Droppable/,
  /Draggable/,
  /HexColorPicker/,
  /ColorSelector/,
];
